<template>
  <el-date-picker
    class="date-select"
    v-model="innerValue"
    :type="type"
    :placeholder="placeholder"
    value-format="timestamp"
    :size="size"
    @change="onChange"
    clearable
    prefix-icon="none"
    :editable="false"
  ></el-date-picker>
</template>

<script>
export default {
  name: 'DateSelect',
  props: {
    // .sync  秒数
    value: {
      default: '',
    },
    type: {
      type: String,
      default: 'datetime',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.innerValue = val ? val * 1000 : '';
      },
    },
  },
  data() {
    return {
      innerValue: '',
    };
  },
  methods: {
    onChange() {
      const val = this.innerValue ? parseInt(+this.innerValue / 1000) : '';
      this.$emit('update:value', val);
    },
  },
};
</script>

<style lang="scss" scoped>
.date-select {
  width: 188px;
  ::v-deep.el-input__inner {
    padding-left: 15px;
  }
}
</style>
